import { Injectable, Signal } from '@angular/core';
import { DateTimeOptionQueryParams, DateTimeOptionValue } from './date-time-selector.model';
import { BehaviorSubject } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable({ providedIn: 'root' })
export class DateTimeSelectorService {

    public dateTimeOptionQueryParams: BehaviorSubject<DateTimeOptionQueryParams>;
    public readonly dateTimeFilterTrigger: Signal<DateTimeOptionQueryParams>;

    constructor() {
        this.dateTimeOptionQueryParams = new BehaviorSubject({ interval: DateTimeOptionValue.TODAY } as DateTimeOptionQueryParams);
        this.dateTimeFilterTrigger = toSignal(this.dateTimeOptionQueryParams, { requireSync: true });

    }
}
